import React from 'react';
import { Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.twoFactor.Success');
export default function Success(props) {
  const message = Config.get('SecurityScreen', 'twoStepSuccessMessage', t('twoStepSuccessMessage'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    width: 40,
    height: 40,
    alt: t('success'),
    src: "https://molten-ui-assets.storage.googleapis.com/two-step-success.png"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "twoStepTitle|title"
  }, t('title')), /*#__PURE__*/React.createElement(Text, null, message));
}